import { Component, OnInit, inject } from '@angular/core';
import { PageComponent } from '../../../../../components/pages/page.component';
import { APPLICATION_ROUTES } from '../../../../../constants/application-routes';
import { AdobePageName } from '../../../../../services/adobe-launch/adobe-launch.pages';
import { AdobeLaunchService } from '../../../../../services/adobe-launch/adobe-launch.service';
import { TitleService } from '../../../../../services/title/title.service';

import { ContentUtil } from '../../../../../utils/content/content.util';
import { InterstitialPageContentComponent } from '../../../../../components/interstitial-page-content/interstitial-page-content.component';

@Component({
    selector: 'zci-edit-user-access-page',
    templateUrl: './edit-user-access-page.component.html',
    imports: [
        InterstitialPageContentComponent,
    ],
})
export class EditUserAccessPageComponent extends PageComponent implements OnInit {
    private readonly adobeLaunchService = inject(AdobeLaunchService);
    private titleService = inject(TitleService);

    content = ContentUtil.content;

    appRoutes = APPLICATION_ROUTES;

    ngOnInit(): void {
        this.titleService.setTitle(this.content.userInterstitialPages.editUser.pageTitle);
        this.adobeLaunchService.pageLoad(AdobePageName.USERS_EDIT_ACCESS_PAGE);
    }
}
